import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetTestConfigsResponse } from '@eggplant/types'

export interface Props {
  webhook_id: string
  onSuccess: (testConfigs: GetTestConfigsResponse) => void
  configType?: 'test' | 'monitor'
}

const GetWebhookTestConfigRequest = ({
  webhook_id,
  onSuccess,
  configType = 'test'
}: Props) => {
  const params = {
    webhook_id,
    type: configType
  }

  const { requestParams } = useGetParamsWithSpaceId(params)

  const url = `${TEST_CONFIG_SERVICE}/test_configurations`

  return (
    <AuthenticatedDataRequest
      method='get'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetWebhookTestConfigRequest
